export default "__VITE_ASSET__DN0m$1Ww__"